import React from "react"
import propTypes from "prop-types"
import { Route, Switch } from "react-router-dom"
import { connect } from "react-redux"
import { fetchPlan, fetchPlansAnswers } from "../../services/plans"
import { signOut } from "../../services/authentication"
import "./styles.scss"
import configs from "../../configs"

import IdleTimeout from "../../components/IdleTimeout"
import PrivateRoute from "../../components/PrivateRoute"
import Home from "./scenes/Home"
import GeneralInformation from "./scenes/GeneralInformation"
import MyPlan from "./scenes/MyPlan"
import Profile from "./scenes/Profile"
import PrePlan from "./scenes/PrePlan"
import Welcome from "./scenes/Welcome"
import PageNotFound from "../Public/PageNotFound"
import Congratulations from "./scenes/Congratulations"
import Almost from "./scenes/Almost"
import MyParticipants from "./scenes/MyParticipants"
import Activity from "./scenes/Activity"

class App extends React.Component {
  componentDidMount() {
    const { onFetchPlan, onFetchPlansAnswers, store } = this.props

    if (store.user.token) {
      onFetchPlan(store.user.token)
        .then(planId => {
          onFetchPlansAnswers(store.user.token, planId)
        })
        .catch(() => {})
    }
  }

  render() {
    const { onSignOut, store } = this.props

    return (
      <>
        <IdleTimeout onSignOut={onSignOut} />
        <Switch>
          <PrivateRoute
            exact
            notifications={!!store.notificationsUnread.length}
            path="/"
            component={Home}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            path="/my-participants"
            component={MyParticipants}
            roles={[configs.roles.Guardian]}
          />
          <PrivateRoute
            path="/activity"
            component={Activity}
            roles={[configs.roles.Guardian]}
          />
          <PrivateRoute
            path="/general-information"
            component={GeneralInformation}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            notifications={!!store.notificationsUnread.length}
            path={["/my-plan/:tab", "/my-plan"]}
            component={MyPlan}
            roles={[configs.roles.Participant]}
          />
          <PrivateRoute
            path="/profile"
            component={Profile}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            exact
            path="/pre-plan/almost"
            component={Almost}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            exact
            path="/pre-plan/congratulations"
            component={Congratulations}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            path="/pre-plan/:step/:id"
            component={PrePlan}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            path="/pre-plan/:step"
            component={PrePlan}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <PrivateRoute
            path="/pre-plan/"
            component={Welcome}
            roles={[configs.roles.Guardian, configs.roles.Participant]}
          />
          <Route component={PageNotFound} />
        </Switch>
      </>
    )
  }
}

App.propTypes = {
  onFetchPlan: propTypes.func.isRequired,
  onFetchPlansAnswers: propTypes.func.isRequired,
  onSignOut: propTypes.func.isRequired,
  store: propTypes.shape({
    notificationsUnread: propTypes.arrayOf(
      propTypes.shape({
        id: propTypes.oneOfType([propTypes.string, propTypes.number]),
        description: propTypes.string,
        href: propTypes.string
      })
    ),
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string
    }).isRequired,
    planId: propTypes.oneOfType([propTypes.string, propTypes.number])
  }).isRequired
}

const mapStateToProps = ({
  NotificationsReducer,
  AuthenticationReducer,
  PlansReducer
}) => ({
  store: {
    notificationsUnread: NotificationsReducer.unread,
    user: AuthenticationReducer.user,
    planId: PlansReducer.id,
    answers: PlansReducer.answers
  }
})

const mapDispatchToProps = dispatch => ({
  onFetchPlan: token => dispatch(fetchPlan(token)),
  onFetchPlansAnswers: (token, planId) =>
    dispatch(fetchPlansAnswers(token, planId)),
  onSignOut: () => dispatch(signOut())
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
